import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";

/**
 * useApprovalCalls — polls Away Mode's active approval-call queue so the
 * Floor can show "Nova is trying to reach someone" while she's ringing the
 * away roster on a VA's behalf. Backed by `floor_calls.py`'s
 * `approval_call_loop` + `GET /api/floor/calls/approval-calls/active`.
 */
export function useApprovalCalls({ pollMs = 8000 } = {}) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await apiClient.get("/floor/calls/approval-calls/active");
        if (alive) setItems(Array.isArray(data?.items) ? data.items : []);
      } catch {
        // silent — this is a peripheral indicator, not core data
      }
    };
    load();
    const t = setInterval(load, pollMs);
    return () => { alive = false; clearInterval(t); };
  }, [pollMs]);

  const calling = items.filter((i) => i.escalation_state?.status === "waiting_for_answer");
  return { items, calling };
}
